import { render, staticRenderFns } from "./PageHeaderBackground.vue?vue&type=template&id=4fe4e565&"
import script from "./PageHeaderBackground.vue?vue&type=script&lang=js&"
export * from "./PageHeaderBackground.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderBackground.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports